import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-requirement"
export default class extends Controller {
  static targets = ["newPassword", "passwordConfirmation", "currentPassword", "requiredIndicator", "helpText"]

  connect() {
    this.updatePasswordRequirement()
  }

  checkPasswordFields() {
    this.updatePasswordRequirement()
  }

  updatePasswordRequirement() {
    const hasNewPassword = this.newPasswordTarget.value.trim() !== ""
    const hasPasswordConfirmation = this.passwordConfirmationTarget.value.trim() !== ""
    const isChangingPassword = hasNewPassword || hasPasswordConfirmation

    // Показываем/скрываем индикатор обязательности (*)
    if (this.hasRequiredIndicatorTarget) {
      this.requiredIndicatorTarget.style.display = isChangingPassword ? "inline" : "none"
    }

    // Обновляем текст подсказки
    if (this.hasHelpTextTarget) {
      if (isChangingPassword) {
        this.helpTextTarget.innerHTML = '<i class="fa-solid fa-exclamation-triangle me-1"></i>Обязательно при изменении пароля'
        this.helpTextTarget.className = "form-text text-warning"
      } else {
        this.helpTextTarget.innerHTML = '<i class="fa-solid fa-info-circle me-1"></i>Требуется только при изменении пароля'
        this.helpTextTarget.className = "form-text text-muted"
      }
    }

    // Обновляем required атрибут для поля текущего пароля
    if (this.hasCurrentPasswordTarget) {
      this.currentPasswordTarget.required = isChangingPassword
      
      // Обновляем placeholder
      if (isChangingPassword) {
        this.currentPasswordTarget.placeholder = "Введите текущий пароль для подтверждения"
      } else {
        this.currentPasswordTarget.placeholder = "Требуется только при изменении пароля"
      }
    }
  }
}
